import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9tvmkl3pcjqs2fcsjdg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || '订阅失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-xs text-background-50/70 tracking-widest uppercase mb-2">保持联系</p>
        <h2 className="text-2xl md:text-3xl font-bold text-background-50">
          订阅春日灵感
        </h2>
        <p className="mt-3 text-background-50/80 text-sm">
          每周获取最新亚洲春季旅行攻略、花期预报和独家旅行灵感
        </p>

        {status === 'success' ? (
          <div className="mt-8 py-4 px-6 bg-background-50/15 rounded-lg text-background-50 text-sm">
            感谢订阅！春天的美好即将送达您的邮箱。
          </div>
        ) : (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="w-full px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-950 placeholder:text-foreground-400 outline-none"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="absolute opacity-0 pointer-events-none"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap"
            >
              订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-background-50/90 text-xs">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}